<ng-container *ngIf="appointmentServiceDetail && appointmentServiceDetail.appointmentDemandList.length > 0;">
    <div class="row justify-content-center pb15">
        <div class="col-10 col-sm-10 col-md-11 col-lg-10 text-right">
            <button type="button" class="btn btn-primary " *ngIf="approveAllOrder && currentAppointment.IsActiveAppointment" (click)="ApproveAllDemand(ApproveAll)" translate>
                lblApproveAll
            </button>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-11 col-lg-10">
            <div *ngFor="let Service of appointmentServiceDetail.appointmentDemandList">
                <div class="bg-light p-3 jobBlock" *ngIf="Service.sentForCustomerApproval">
                    <div class="alert alert-warning mb-2 font18 text-center" *ngIf="Service.sentForCustomerApproval && Service.customerReply==='Pending' && (repairStatusId!==7 && repairStatusId!==9 && repairStatusId!==10)">
                        <em class="fa fa-exclamation-triangle font22 vm mr-1"></em> <span translate>lblNeedPriorApproval</span>
                    </div>
                    <div class="alert alert-warning mb-2 font18 text-center" *ngIf="(repairStatusId===7 || repairStatusId===9 || repairStatusId===10) && Service.sentForCustomerApproval && Service.customerReply==='Pending'">
                        <em class="fa fa-exclamation-triangle font22 vm mr-1"></em> <span translate>lblDemandNotApproved</span>
                    </div>
                    <div>
                        <div class="d-flex " *ngIf="Service.sentForCustomerApproval && Service.customerReply==='Approved'">
                            <p class="h5 font16 font-weight-bold">
                                <em class="fa fa-check-circle text-success"></em> {{Service.shortDescription}}
                            </p>
                            <p class="h5 font16 text-success font-weight-bold ml-auto pl-2" *ngIf="!Service.isHidePrice">
                                {{(Service.isInWarranty ? '' : Service.sumPerServiceInclTax) | number:'1.2-2'}}
                            </p>
                            <p class="h5 font16 font-weight-bold pl-2 demand-action-icon" [ngClass]="!Service.isHidePrice ? 'ml-3' : 'ml-auto'" *ngIf="customerUploadedDocument && currentAppointment.IsActiveAppointment">
                                <button type="button" class="btn btn-ico" class="d-flex"  aria-label="Close" placement="bottom" container="body" ngbTooltip="{{ 'lblUploadDocument' | translate }}"  (click)="OpenModel(Service)"><em class="fa fa-upload fa-sm" tooltipClass="custom-revert"></em></button>
                            </p>
                            <p class="h5 font16 font-weight-bold ml-3 pl-2 demand-action-icon"  *ngIf="customerUploadedDocument">
                                <button type="button" class="d-flex" (click)="ViewDocument(Service)" aria-label="Center Align" ngbTooltip="{{'lblViewDocument' | translate}}" tooltipClass="custom-revert">
                                    <em class="fas fa-eye fa-sm"></em>
                                    <span id = "1" class="position-relative translate-middle badge rounded-pill count">
                                        {{ Service?.docCount }}
                                    </span>
                                </button>
                            </p>
                        </div>
                        <div class="d-flex " *ngIf="Service.sentForCustomerApproval && Service.customerReply==='Rejected'">
                            <p class="h5 font16 font-weight-bold">
                                <em class="fa fa-ban text-danger"></em> {{Service.shortDescription}}
                            </p>
                            <p class="h5 font16 text-danger font-weight-bold ml-auto pl-2" *ngIf="!Service.isHidePrice">
                                {{(Service.isInWarranty ? '' : Service.sumPerServiceInclTax) | number:'1.2-2'}}
                            </p>
                            <p class="h5 font16 font-weight-bold pl-2 demand-action-icon" [ngClass]="!Service.isHidePrice ? 'ml-3' : 'ml-auto'" *ngIf="customerUploadedDocument && currentAppointment.IsActiveAppointment">
                                <button type="button" class="btn btn-ico" class="d-flex"  aria-label="Close" placement="bottom" container="body" ngbTooltip="{{ 'lblUploadDocument' | translate }}"  (click)="OpenModel(Service)"><em class="fa fa-upload fa-sm" tooltipClass="custom-revert"></em></button>
                            </p>
                            <p class="h5 font16 font-weight-bold ml-3 pl-2 demand-action-icon"  *ngIf="customerUploadedDocument">
                                <button type="button" class="d-flex" (click)="ViewDocument(Service)" aria-label="Center Align" ngbTooltip="{{'lblViewDocument' | translate}}" tooltipClass="custom-revert">
                                    <em class="fas fa-eye fa-sm"></em>
                                    <span id = "1" class="position-relative translate-middle badge rounded-pill count">
                                        {{ Service?.docCount }}
                                    </span>
                                </button>
                            </p>
                        </div>
                        <div class="d-flex" *ngIf="Service.sentForCustomerApproval && Service.customerReply==='Pending'">
                            <p class="h5 font16 font-weight-bold">
                                <em class="fa fa-exclamation-circle text-warning "></em> {{Service.shortDescription}}
                            </p>
                            <p class="h5 font16 text-warning font-weight-bold ml-auto pl-2" *ngIf="!Service.isHidePrice">
                                {{(Service.isInWarranty ? '' : Service.sumPerServiceInclTax) | number:'1.2-2'}}
                            </p>
                            <p class="h5 font16 font-weight-bold pl-2 demand-action-icon" [ngClass]="!Service.isHidePrice ? 'ml-3' : 'ml-auto'" *ngIf="customerUploadedDocument && currentAppointment.IsActiveAppointment">
                                <button type="button" class="d-flex" aria-label="Close" ngbTooltip="{{ 'lblUploadDocument' | translate }}"  (click)="OpenModel(Service)"><em class="fa fa-upload fa-sm" tooltipClass="custom-revert"></em></button>
                            </p>
                            <p class="h5 font16 font-weight-bold ml-3 pl-2 demand-action-icon"  *ngIf="customerUploadedDocument">
                                <button type="button" class="d-flex" (click)="ViewDocument(Service)" aria-label="Center Align" ngbTooltip="{{'lblViewDocument' | translate}}" tooltipClass="custom-revert">
                                    <em class="fas fa-eye fa-sm"></em>
                                    <span id = "1" class="position-relative translate-middle badge rounded-pill count">
                                        {{ Service?.docCount }}
                                    </span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <p *ngIf="Service.SentForCustomerApproval">
                        {{Service.shortDescription}}
                    </p>
                    <div *ngIf="repairStatusId!==7 && repairStatusId!==9 && repairStatusId!==10">
                        <div class="btn-section" *ngIf="(Service.sentForCustomerApproval && Service.customerReply==='Pending') || (Service.sentForCustomerApproval && Service.customerReply==='Rejected' && showData && Service.id === buttonJobIds)">
                            <hr>
                            <div class="d-block d-md-flex align-items-center">
                                <div class="font-weight-bold text-nowrap d-flex align-items-center">
                                    <span translate>lblWantToKnowMore</span> <a href="tel:{{dealerPhone}}" class="font-weight-bold btn btn-link d-inline-flex align-items-center" (click)="CallDealerLogEntry()"><em
                                                class="fa fa-phone-square mx-1 font22 align-middle" aria-hidden="true" translate></em><span
                                                translate>lblCallDealer</span></a>
                                </div>
                                <div class="ml-auto" *ngIf="currentAppointment.IsActiveAppointment">
                                    <button type="button" aria-label="Center Align" class="btn btn-primary " (click)="onApprove(ApproveContent,Service)" translate>lblApprove</button>
                                    <button type="button" aria-label="Center Align" class="btn btn-outline-secondary ml-2" (click)="onReject(RejectContent,Service)" translate>lblReject</button>
                                </div>
                            </div>
                        </div>
                        <div class="font-weight-bold d-flex my-2" *ngIf="Service.SentForCustomerApproval && Service.customerReply==='Rejected'">
                            <span class="text-danger" translate>
                                    <span class="mr-4">{{Service.ActionTime | date:'short'}}</span>
                            <em class="fa fa-ban mr-2 align-top mt-1 "></em> lblRejected
                            </span>
                            <a *ngIf="currentAppointment.IsActiveAppointment" class="btn-link ml-auto font-weight-bold" (click)="ShowButtons(Service)" translate>
                                    lblChange
                                </a>
                        </div>
                    </div>
                </div>
                <div class="bg-light p-3 jobBlock" *ngIf="!Service.sentForCustomerApproval">
                    <div class="d-flex">
                        <p class="h5 font16 font-weight-bold">
                            <em class="fa fa-check-circle text-success"></em> {{Service.shortDescription}}
                        </p>
                        <p class="h5 font16 text-success font-weight-bold ml-auto pl-2" *ngIf="!Service.isHidePrice">
                            {{(Service.isInWarranty ? '' : Service.sumPerServiceInclTax) | number:'1.2-2'}}
                        </p>
                        <p class="h5 font16 font-weight-bold pl-2 demand-action-icon" [ngClass]="!Service.isHidePrice ? 'ml-3' : 'ml-auto'" *ngIf="customerUploadedDocument && !Service.isInWarranty && currentAppointment.IsActiveAppointment">
                            <button type="button" class="d-flex" aria-label="Close" ngbTooltip="{{ 'lblUploadDocument' | translate }}"  (click)="OpenModel(Service)"><em class="fa fa-upload fa-sm" tooltipClass="custom-revert"></em></button>
                        </p>
                        <p class="h5 font16 font-weight-bold ml-3 pl-2 demand-action-icon"  *ngIf="customerUploadedDocument && !Service.isInWarranty">
                            <button type="button" class="d-flex" (click)="ViewDocument(Service)" aria-label="Center Align" ngbTooltip="{{'lblViewDocument' | translate}}" tooltipClass="custom-revert">
                                <em class="fas fa-eye fa-sm"></em>
                                <span  class="position-relative translate-middle badge rounded-pill count">
                                    {{ Service?.docCount }}
                                </span>
                            </button>
                        </p>
                    </div>
                    <div class="font-weight-bold d-flex my-2">
                        <span class="text-success" translate>
                        <em class="fa fa-check-circle text-success"></em> lblApprovedByDealer
                        </span>
                    </div>
                </div>
                <div class="row justify-content-center" *ngIf="Service.documnets && Service.documnets.length>0 && !Service.isInWarranty">
                    <div class="col-12 col-sm-12 col-md-11 col-lg-6">
                        <ngb-carousel>
                            <ng-template ngbSlide *ngFor="let demandFile of Service.documnets">
                                <div class="picsum-img-wrapper text-center">
                                    <img class="img-fluid" af-image [data-code]="demandFile.path" alt="demand" *ngIf="demandFile.fileType==='image'">
                                    <img class="img-fluid" src="/assets/audio-icon.png" alt="audio" *ngIf="demandFile.fileType==='audio'">
                                    <img class="img-fluid" src="/assets/video.png" alt="video" *ngIf="demandFile.fileType==='video'">
                                    <img class="img-fluid" src="/assets/PDF_icon.png" alt="document" *ngIf="demandFile.fileType==='document'">
                                </div>
                                <button type="button" class="btn btn-outline-primary my-3" (click)="downloadFile(demandFile.path);">
                                    <em class="fas fa-download fa-lg mr-2"></em>
                                    <span translate>lblDownload</span>
                                </button>
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="noRecords">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-11 col-lg-10">
            <div class="alert alert-warning mb-2 font18 text-center" translate>lblNoServicesIdentified</div>
        </div>
    </div>
</ng-container>

<ng-template #ApproveContent let-modal>

    <div class="modal-header">
        <h4 class="modal-title" translate>lblConfirmApprove</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>lblAreYouSureWantToApprove</p>
    </div>
    <div class="modal-footer">
        <button type="button" aria-label="Center Align" class="btn btn-danger" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" aria-label="Center Align" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblClose</button>
    </div>
</ng-template>

<ng-template #RejectContent let-modal>

    <div class="modal-header">
        <h4 class="modal-title" translate>lblConfimrReject</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>lblAreYouSureWantToReject</p>
    </div>
    <div class="modal-footer">
        <button type="button" aria-label="Center Align" class="btn btn-danger" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" aria-label="Center Align" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblClose</button>
    </div>
</ng-template>

<ng-template #ApproveAll let-modal>
    <div class="modal-header">
        <h4 class="modal-title" translate>lblConfirmApprove</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
          <span aria-hidden="true" class="font18">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>lblAreYouSureWantToApprove</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.dismiss(true)" translate>lblYes</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)" translate>lblClose</button>
    </div>
</ng-template>